import { Model } from './model';

export class BaseChart extends Model {
  constructor(
    public dataSet: number[],
    public label?: string,
    public backgroundColor?: string[] | string,
    public borderColor?: string,
    public changeRate?: number[]
  ) {
    super();
    this.dataSet = dataSet;
    this.label = label;
    this.backgroundColor = backgroundColor;
    this.borderColor = borderColor
    this.changeRate = changeRate;
  }
}
